import { Folder } from "../../redux/interfaces/folder.types.ts";

/**
 * MB-379 — el metadata de un folio tal como se puede REENVIAR al guardar.
 *
 * Quita `renewal`: el detalle lo emite calculado (con `renewed_into` resuelto al leer y
 * null en lo que no aplica), no es un dato que el usuario edite, y reenviarlo al guardar
 * un participante hacía que el folio de ORIGEN de una renovación acabara guardando un
 * bloque `renewal` que por diseño no tiene. El backend ya lo ignora, pero el front no
 * debería mandar como dato lo que recibió como cálculo.
 */
export const metadataForSave = (
  metadata: Folder["metadata"] | null | undefined,
): Omit<NonNullable<Folder["metadata"]>, "renewal"> | Record<string, never> => {
  if (!metadata) return {};
  const { renewal: _derivedRenewal, ...stored } = metadata;
  return stored;
};
